import styled from "styled-components";

// Styled Components
export const PopupContainer = styled.div`
    padding: 10px;
    min-width: 280px;
    max-width: 320px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
        sans-serif;
    font-size: 13px;
    line-height: 1.4;
    color: #333;
`;

export const Header = styled.div`
    margin-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 8px;
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
`;

export const Section = styled.div`
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const SectionTitle = styled.h4`
    margin: 0 0 6px 0;
    font-size: 13px;
    font-weight: 600;
    color: #333;
`;

export const List = styled.ul`
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
`;

export const ListItem = styled.li`
    margin-bottom: 3px;
    color: #666;
    font-size: 12px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const Status = styled.span`
    font-weight: 600;
`;

export const NoData = styled.div`
    margin-top: 8px;
    color: #999;
    font-style: italic;
    font-size: 13px;
`;

export const CollapsibleHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 12px;

    &:hover {
        background-color: #f9f9f9;
        border-radius: 4px;
        padding: 8px 4px;
        margin: 0 -4px 12px -4px;
    }
`;

export const CollapsibleTitle = styled.h4`
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #333;
`;

export const CollapsibleIcon = styled.span`
    color: #666;
    font-size: 12px;
    transition: transform 0.2s ease;
`;

export const CollapsibleContent = styled.div`
    overflow: hidden;
    transition: max-height 0.3s ease, opacity 0.3s ease;
    max-height: ${props => (props.isOpen ? "500px" : "0")};
    opacity: ${props => (props.isOpen ? "1" : "0")};
`;
